import SearchImpressionShare from "./MetricsCharts/SearchImpressionShare";
import TopPageRate from "./MetricsCharts/TopPageRate";
import PositionAboveRate from "./MetricsCharts/PositionAboveRate";

const CompetitorMetrics = () => {
  return (
    <>
      <SearchImpressionShare/>
      <TopPageRate/>
      <PositionAboveRate/>
    </>
  );
};

export default CompetitorMetrics;
